// SpecialtyCare.js
import React from 'react';
import ServiceHero from '../components/ServiceHero';
import ComprehensiveSpecialtyCareSection from '../components/ComprehensiveSpecialtyCareSection';
import ProudlyCaringSeniorsSection from '../components/ProudlyCaringSeniorsSection';
import SpecializedInHomeSupportSection from '../components/SpecializedInHomeSupportSection';
import ProvidingExpertSpecialtyCareSection from '../components/ProvidingExpertSpecialtyCareSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const SpecialtyCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: '/services' },
    { label: 'Specialty Care', link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <ServiceHero
        breadcrumbs={breadcrumbs}
        title="Specialty Care at Home for Complex Health Needs"
        description="From hospital-to-home transitions to disability support, Parkinson's, and chronic-condition care, we tailor in-home help across Canberra and the ACT."
      />
      <ComprehensiveSpecialtyCareSection />
      <ProudlyCaringSeniorsSection />
      <SpecializedInHomeSupportSection />
      <ProvidingExpertSpecialtyCareSection />
      <ThreeStepsSection />
      <AllServicesShowcase />
    </div>
  );
};

export default SpecialtyCare;
